import { Menus } from '@cTypes/user';
import { ApiMenuListItem } from './types';
import { isObject, isArray } from 'lodash';
import { storeToRefs } from 'pinia';
import appStore from '@/store';

export const menuListTranslator: (
  resp: Result<ApiMenuListItem>
) => Result<Menus | []> = resp => {
  const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);

  // const { data, ...options } = resp;
  // const _resp: Result<Menus> = options;
  // _resp.data = Object.values(data)
  //   .filter(item => item)
  //   .reduce((pre, cur) => {
  //     return pre.concat(cur);
  //   }, []);

  const { data, ...options } = resp;
  let menuList = [];
  // 后端返回数据必是对象，且对象必有属性
  if (isObject(data)) {
    const {
      gyMenuList,
      csoMenuList,
      gysMenuList,
      dbgysMenuList,
      // jdMenuList,
      staffMenuList
    } = data;
    // 工业
    if (
      defaultUserFnCode.value === 1 &&
      isArray(gyMenuList) &&
      gyMenuList.length
    ) {
      menuList = gyMenuList;
    }
    // 服务商
    else if (
      defaultUserFnCode.value === 2 &&
      isArray(csoMenuList) &&
      csoMenuList.length
    ) {
      menuList = csoMenuList;
    }
    // 供应商
    else if (
      defaultUserFnCode.value === 3 &&
      isArray(gysMenuList) &&
      gysMenuList.length
    ) {
      menuList = gysMenuList;
    }
    // 代办供应商
    else if (
      defaultUserFnCode.value === 8 &&
      isArray(dbgysMenuList) &&
      dbgysMenuList.length
    ) {
      menuList = dbgysMenuList;
    }

    // 运营基地暂时不做了
    // if (isArray(jdMenuList) && jdMenuList.length) {
    //   menuList.push({
    //     id: 100004,
    //     name: '基地业务域',
    //     url: '/supplier',
    //     permissionDef: '100004',
    //     resourceType: 2,
    //     icon: '',
    //     sort: 4,
    //     menuList: jdMenuList
    //   });
    // }

    // 其他公共的菜单
    if (isArray(staffMenuList) && staffMenuList.length) {
      [].push.apply(menuList, staffMenuList);
    }
  }
  // mock数据，懒得改结构了
  if (isArray(data)) {
    menuList = data;
  }

  const _resp: Result<Menus> = options;
  _resp.data = menuList;
  return _resp;
};
